import { Generator } from "../generator";

export class ContainerModule {
    constructor(registry) {
        this.id = Generator.GenAutoIncrementId(), this.registry = registry;
    }
}
//# sourceMappingURL=cotainer-module.js.map
